import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import MainLayoutDemand from "../../MainLoyout/MainLayoutDemand";

const KeywordLayout = ({ children }) => {
  return (
    <MainLayoutDemand>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
          }}
        >
          {children}
        </Paper>
      </Container>
    </MainLayoutDemand>
  );
};

export default KeywordLayout; 